"use strict";

var _interopRequireDefault = require("/app/node_modules/.pnpm/@babel+runtime@7.25.6/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.postConfigUpdate = exports.getConfigOne = void 0;
var _axios = _interopRequireDefault(require("@/utils/axios"));
/**
 * 用户自定义表头设置
 * @param {object} params
 * @param {string} params.code 表头编码
 * @param {string} params.titleValue 表头内容
 * @param {string} params.type 设置类型： 0 默认设置，1 用户设置
 */
const postConfigUpdate = params => _axios.default.post('/v1/title/config/update', params);

/**
 * 用户自定义表头设置查询
 * @param {object} params
 * @param {string} params.code 表头编码
 * @returns {Promise<{
 *   id: string
 *   code: string
 *   titleValue: string
 *   type: string
 * }>} ** 返回体 **
 *   - id: 设置ID
 *   - code: 表头编码
 *   - titleValue: 表头设置内容
 *   - type: 表头类型： 0 默认设置, 1 用户设置
 */
exports.postConfigUpdate = postConfigUpdate;
const getConfigOne = params => _axios.default.get('/v1/title/config/one', {
  params
});
exports.getConfigOne = getConfigOne;